import React, { useState, useEffect } from 'react';
import useRequireAuth from '../../hooks/useRequireAuth';
import { getInsuranceTypeName, INSURANCE_TYPE } from '../../utils/insuranceTypeUtils';
import DocumentTypeOptions from '../../components/DocumentTypeOptions';

const AgencyInfoTab = ({ formData, handleChange, onConfirm, onReturn, documentTypes = [], selectedDocumentTypeIds = [], onDocumentTypeToggle = () => {} }) => {
  const userInfo = useRequireAuth();

  // 日付のみを表示する関数（YYYY/MM/DD形式に変換）
  const formatDateForDisplay = (dateTimeString) => {
    if (!dateTimeString) return '';

    // 日付部分を取得
    let datePart = '';

    if (dateTimeString.includes('T')) {
      datePart = dateTimeString.split('T')[0];
    } else {
      datePart = dateTimeString;
    }

    // スラッシュ形式をハイフン形式に変換（input[type="date"]用）
    if (datePart.includes('/')) {
      return datePart.replace(/\//g, '-');
    }

    return datePart;
  };

  // localStorage からユーザ種別を取得し、代理店ユーザかどうか判定
  const [userType] = useState(() => localStorage.getItem('userType'));
  const isAgency = userType === 'agency';

  return (
    <>
      <table className="info-table c-max-middle">
        <tbody>
          <tr>
            {(!userInfo?.is_agent || userInfo?.is_admin) && (
              <>
                <th>取引先コード</th>
                <td>
                  <input
                    className="form-input"
                    type="text"
                    name="tradingCode"
                    value={formData.tradingCode}
                    onChange={handleChange}
                  />
                </td>
              </>
            )}
            <th>アカウント名（メールアドレス）</th>
            <td>
              <input
                className="form-input"
                type="email"
                name="accountname"
                value={formData.accountname}
                onChange={handleChange}
                required
              />
            </td>
          </tr>
          <tr>
            <th>代理店名</th>
            <td colSpan="3">
              <input
                className="form-input"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isAgency}  // 代理店ユーザは編集不可
              />
            </td>
          </tr>
          <tr>
            <th>代理店カナ</th>
            <td colSpan="3">
              <input
                className="form-input"
                type="text"
                name="nameKana"
                value={formData.nameKana}
                onChange={handleChange}
                disabled={isAgency}   // 代理店ユーザは編集不可
              />
            </td>
          </tr>
          {(!userInfo?.is_agent || userInfo?.is_admin) && (
          <tr>
            <th>契約日</th>
            <td>
              <input
                className="form-input"
                type="date"
                max="9999-12-31"
                name="contractDate"
                value={formatDateForDisplay(formData.contractDate)}
                onChange={handleChange}
              />
            </td>
            <th>解除日/契約終了日</th>
            <td>
              <input
                className="form-input"
                type="date"
                max="9999-12-31"
                name="cancellationDate"
                value={formatDateForDisplay(formData.cancellationDate)}
                onChange={handleChange}
              />
            </td>
          </tr>
          )}
          <tr>
            <th>郵便番号</th>
            <td>
              <input
                className="form-input"
                type="text"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
              />
            </td>
            <th>住所・都道府県</th>
            <td>
              <input
                className="form-input"
                type="text"
                name="prefecture"
                value={formData.prefecture}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <th>住所・市区町村</th>
            <td colSpan="3">
              <input
                className="form-input"
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <th>住所・ビル名</th>
            <td colSpan="3">
              <input
                className="form-input"
                type="text"
                name="building"
                value={formData.building}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td colSpan="3">
              <input
                className="form-input"
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </td>
          </tr>
          {userInfo?.is_admin && (
            <tr>
              <th>文書種別</th>
              <td colSpan="3">
                <div className="document-type-section">
                  <div className="document-type-grid">
                    <div className="document-type-group">
                      <div className="document-type-heading">{getInsuranceTypeName(INSURANCE_TYPE.LIFE)}</div>
                      <div className="document-type-options">
                        {/* 文書種別アクセス権（生保） */}
                        <DocumentTypeOptions
                          insuranceType={INSURANCE_TYPE.LIFE}
                          documentTypes={documentTypes}
                          selectedDocumentTypeIds={selectedDocumentTypeIds}
                          onDocumentTypeToggle={onDocumentTypeToggle}
                        />
                      </div>
                    </div>
                    <div className="document-type-group">
                      <div className="document-type-heading">{getInsuranceTypeName(INSURANCE_TYPE.SONPO)}</div>
                      <div className="document-type-options">
                        {/* 文書種別アクセス権（損保） */}
                        <DocumentTypeOptions
                          insuranceType={INSURANCE_TYPE.SONPO}
                          documentTypes={documentTypes}
                          selectedDocumentTypeIds={selectedDocumentTypeIds}
                          onDocumentTypeToggle={onDocumentTypeToggle}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="action-buttons c-max-mini c-m-center">
        <button 
          type="button" 
          className="button button-secondary button-medium" 
          onClick={onReturn}
        >
          戻る
        </button>
        <button className="btn btn-primary button-medium" onClick={onConfirm}>変更を保存する</button>
      </div>
    </>
  );
};

export default AgencyInfoTab;
